// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-width: 150px;
  margin-right: 10px;
  cursor: pointer;
}
.container .value-label-parent {
  border: 1px solid var(--ion-color-light);
  border-radius: 4px;
  overflow: hidden;
  display: table;
  width: 100%;
}
.container .value-label-parent .value-label {
  display: table-cell;
  vertical-align: middle;
  margin-left: 5px;
  text-align: right;
  width: 80%;
  padding-top: 2px;
}
.container .value-label-parent .icon {
  float: right;
  height: 15px;
  font-size: 15px;
}

.pop-over::part(content) {
  border: 1px solid var(--ion-color-light);
  border-radius: 4px;
  margin-top: 2px;
}
.pop-over::part(arrow) {
  width: 0;
  height: 0;
}

.state-options .state-option {
  height: 1.5em;
}
.state-options .state-option:nth-child(1) {
  padding-top: 3px;
}
.state-options .state-option::part(native) {
  --min-height: 1em;
  --inner-padding-end: 3px;
  --padding-start: 5px;
}

.popup-lable {
  margin: 0;
  font-size: 14px;
}

ion-radio {
  margin: 0;
  margin-inline-start: 0;
}

ion-radio::part(container) {
  border: 0;
}

ion-radio::part(mark) {
  background: none;
  transition: none;
  transform: none;
  border-radius: 0;
}

ion-radio.radio-checked::part(container) {
  background: transparent;
  border-color: transparent;
}

ion-radio.radio-checked::part(mark) {
  width: 6px;
  height: 10px;
  border-width: 0px 2px 2px 0px;
  border-style: solid;
  border-color: var(--ion-color-primary);
  transform: rotate(45deg);
}

ion-popover.select-popover {
  --offset-y: calc(0% - env(safe-area-inset-top)) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/playin-state-selector/playin-state-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AACJ;AACI;EACE,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AACN;AAEI;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAAN;;AAME;EACE,wCAAA;EACA,kBAAA;EACA,eAAA;AAHJ;AAME;EACE,QAAA;EACA,SAAA;AAJJ;;AASE;EAKE,aAAA;AAVJ;AAMI;EACE,gBAAA;AAJN;AASI;EACE,iBAAA;EACA,wBAAA;EACA,oBAAA;AAPN;;AAYA;EACE,SAAA;EACA,eAAA;AATF;;AAYA;EACE,SAAA;EACA,sBAAA;AATF;;AAYA;EACE,SAAA;AATF;;AAYA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,uBAAA;EACA,yBAAA;AATF;;AAYA;EACE,UAAA;EACA,YAAA;EAEA,6BAAA;EACA,mBAAA;EACA,sCAAA;EAEA,wBAAA;AAXF;;AAcA;EACE,0DAAA;AAXF","sourcesContent":[".container {\r\n  min-width: 150px;\r\n  margin-right: 10px;\r\n  cursor: pointer;\r\n\r\n  .value-label-parent {\r\n    border: 1px solid var(--ion-color-light);\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    display: table;\r\n    width: 100%;\r\n\r\n    .value-label {\r\n      display: table-cell;\r\n      vertical-align: middle;\r\n      margin-left: 5px;\r\n      text-align: right;\r\n      width: 80%;\r\n      padding-top: 2px;\r\n    }\r\n\r\n    .icon {\r\n      float: right;\r\n      height: 15px;\r\n      font-size: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.pop-over {\r\n  &::part(content) {\r\n    border: 1px solid var(--ion-color-light);\r\n    border-radius: 4px;\r\n    margin-top: 2px;\r\n  }\r\n\r\n  &::part(arrow) {\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n}\r\n\r\n.state-options {\r\n  .state-option {\r\n    &:nth-child(1) {\r\n      padding-top: 3px;\r\n    }\r\n\r\n    height: 1.5em;\r\n\r\n    &::part(native) {\r\n      --min-height: 1em;\r\n      --inner-padding-end: 3px;\r\n      --padding-start: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n.popup-lable {\r\n  margin: 0;\r\n  font-size: 14px;\r\n}\r\n\r\nion-radio {\r\n  margin: 0;\r\n  margin-inline-start: 0;\r\n}\r\n\r\nion-radio::part(container) {\r\n  border: 0; // 2px solid #ddd;\r\n}\r\n\r\nion-radio::part(mark) {\r\n  background: none;\r\n  transition: none;\r\n  transform: none;\r\n  border-radius: 0;\r\n}\r\n\r\nion-radio.radio-checked::part(container) {\r\n  background: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\nion-radio.radio-checked::part(mark) {\r\n  width: 6px;\r\n  height: 10px;\r\n\r\n  border-width: 0px 2px 2px 0px;\r\n  border-style: solid;\r\n  border-color: var(--ion-color-primary);\r\n\r\n  transform: rotate(45deg);\r\n}\r\n\r\nion-popover.select-popover {\r\n  --offset-y: calc(0% - env(safe-area-inset-top)) !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
